// extracted by mini-css-extract-plugin
export default {"root":"classes_root__qX5yB","content":"classes_content__PbZ8e","info":"classes_info__3qsUt","text":"classes_text__2N8nE","warning":"classes_warning__SB7GG"};